module.exports = __webpack_public_path__ + "img/card2.0abfaed8.png";